export default "__VITE_ASSET__D1GM7wsA__"